import { useFacetListState } from 'client/state/FacetList';
import { useMemo } from 'react';

const useIsFacetActive = (facetId: string) => {
  const activeFacet = useFacetListState((s) => s.activeFacet);
  return useMemo(() => activeFacet === facetId, [activeFacet, facetId]);
};

export default useIsFacetActive;
